import React from "react";

import MainTemplate from "@/components/Templates/MainTemplate";
import { LiveClassContent } from "./AppTemplate";

function LiveClassPolicy() {
  return (
    <MainTemplate>
      <LiveClassContent showHeader />
    </MainTemplate>
  );
}

export default LiveClassPolicy;
